import { useMemo } from 'react';

import { useAccount } from '@hcs/authn';
import {
  Capability,
  CapabilityApplications,
  CapabilityCategories,
  CapabilityKeys,
} from '@hcs/types';
import { combineUseQueryResult } from '@hcs/utils';

import { useCapabilitiesForUser } from './useCapabilitiesForUser';

type CapabilityFilters = Partial<{
  application: CapabilityApplications[];
  category: CapabilityCategories[];
}>;
export const useCapabilities = (filters?: CapabilityFilters) => {
  const accountQuery = useAccount();
  const capabilitiesQuery = useCapabilitiesForUser(accountQuery.data?.user.id);
  const combinedQuery = combineUseQueryResult([
    accountQuery,
    capabilitiesQuery,
  ]);
  const { application, category } = filters || {};
  const data = useMemo(() => {
    return capabilitiesQuery.data?.filter((c) => {
      if (application?.length && !application.includes(c.application)) {
        return false;
      }
      if (category?.length && (!c.category || !category.includes(c.category))) {
        return false;
      }
      return true;
    });
  }, [application, category, capabilitiesQuery.data]);
  return {
    ...combinedQuery,
    data,
  };
};

export const useCapabilitiesMap = (filters?: CapabilityFilters) => {
  const query = useCapabilities();
  const capablitiesList = query.data;
  return {
    ...query,
    data: useMemo(() => {
      return capablitiesList?.reduce<
        Partial<Record<CapabilityKeys, Capability>>
      >((acc, capability) => {
        acc[capability.key] = capability;
        return acc;
      }, {});
    }, [capablitiesList]),
  };
};
